import { addEventProcessor } from '@sentry/nextjs';
import type { Event } from '@sentry/nextjs';

const MIN_SECRET_LENGTH = 16;

export const REDACTED_SECRET = '[redacted]';

export const redactSecretInEvent = <T extends Event>(
  event: T,
  secret: string,
): T => {
  const serialized = JSON.stringify(event);
  if (!serialized.includes(secret)) {
    return event;
  }
  return JSON.parse(serialized.split(secret).join(REDACTED_SECRET)) as T;
};

/**
 * Removes a bearer secret taken from the page URL (e.g. a magic-link session ID)
 * from every Sentry event and transaction: request URL, breadcrumbs, spans and messages.
 */
export const redactSecretFromEvents = (secret: string): void => {
  if (secret.length < MIN_SECRET_LENGTH) {
    return;
  }
  addEventProcessor((event) => redactSecretInEvent(event, secret));
};
